var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "marketing-consent-overview" }, [
    _c("div", { staticClass: "marketing-consent-overview-container" }, [
      _c(
        "h3",
        {
          staticClass:
            "marketing-consent-overview-title typographies-heading-h3"
        },
        [_vm._v("\n            " + _vm._s(_vm.labels.title) + "\n        ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "marketing-consent-overview__consent" },
        [
          _c(
            "h4",
            {
              staticClass:
                "marketing-consent-overview__consent-title typographies-heading-h4"
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.labels.consent.title) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c("p", {
            staticClass:
              "marketing-consent-overview__consent-information typographies-paragraph-medium-regular",
            domProps: { innerHTML: _vm._s(_vm.labels.consent.information) }
          }),
          _vm._v(" "),
          _c(
            "CompassTooltip",
            {
              attrs: {
                content: _vm.labels.consent.switchButtons.tooltip,
                disabled: _vm.permissions.can_edit_rgpd_consents,
                placement: "top-start"
              }
            },
            [
              _c("CompassSwitch", {
                staticClass: "marketing-consent-overview__consent-switch",
                attrs: {
                  label: _vm.labels.consent.switchButtons.email.label,
                  disabled: !_vm.permissions.can_edit_rgpd_consents,
                  orientation: "left"
                },
                on: { change: _vm.updateConsent },
                model: {
                  value: _vm.consent.marketing.email,
                  callback: function($$v) {
                    _vm.$set(_vm.consent.marketing, "email", $$v)
                  },
                  expression: "consent.marketing.email"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "CompassTooltip",
            {
              attrs: {
                content: _vm.labels.consent.switchButtons.tooltip,
                disabled: _vm.permissions.can_edit_rgpd_consents,
                placement: "top-start"
              }
            },
            [
              _c("CompassSwitch", {
                staticClass: "marketing-consent-overview__consent-switch",
                attrs: {
                  label: _vm.labels.consent.switchButtons.sms.label,
                  disabled: !_vm.permissions.can_edit_rgpd_consents,
                  orientation: "left"
                },
                on: { change: _vm.updateConsent },
                model: {
                  value: _vm.consent.marketing.sms,
                  callback: function($$v) {
                    _vm.$set(_vm.consent.marketing, "sms", $$v)
                  },
                  expression: "consent.marketing.sms"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "marketing-consent-overview__logs" },
        [
          _c(
            "h4",
            {
              staticClass:
                "marketing-consent-overview__logs-title typographies-heading-h4"
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.labels.logs.title) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c("p", {
            staticClass:
              "marketing-consent-overview__logs-information typographies-paragraph-medium-regular",
            domProps: { innerHTML: _vm._s(_vm.labels.logs.information) }
          }),
          _vm._v(" "),
          _c(
            "CompassTooltip",
            {
              attrs: {
                content: _vm.labels.logs.buttons.tooltip,
                disabled: _vm.permissions.can_download_treatments_list,
                placement: "top-start"
              }
            },
            [
              _c("CompassButton", {
                staticClass: "marketing-consent-overview__logs-button",
                attrs: {
                  label: _vm.labels.logs.buttons.download.label,
                  disabled: !_vm.permissions.can_download_treatments_list,
                  type: "secondary",
                  leftIcon: "download"
                },
                on: { click: _vm.sendConsentLogsRequest }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }